export const OPEN_MENU = 'OPEN_MENU'


export function handleMenuChat() {
    return dispatch => {
        dispatch({
            type: OPEN_MENU
        })
    }
}